import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { VentaDetails } from './VentaDetails';
import { ToggleUI } from '../common';

import { ventaObtenerVentas } from '../../store/actions';
const Venta_ = (props) => {
  let history = useHistory();
  const VENTA_ID_THAT_GENERATE_ERROR = -1;
  const [venta_id, setVentaId] = useState(0);
  const [url, setUrl] = useState('');
  const [location, setLocation] = useState(''); //todo: revisar estructura
  const [ultimo_venta_id, setUltimoVentaId] = useState(0);

  useEffect(() => {
    const handleObtenerVentasAsync = async (err, resp) => {
      if (resp.data && resp.data.length && resp.data.length > 0)
        setUltimoVentaId(Number(resp.data[0].v_numero));
      // si hay errores, paso un valor aguas abajo para que se genere un error en Venta
      // que ya tiene el manejo de errores en WrapperLayout
      if (err) setVentaId(Number(VENTA_ID_THAT_GENERATE_ERROR));
    };

    if (props.match && props.match.params && props.match.params.id) {
      setVentaId(Number(props.match.params.id));
      setUrl(props.match.url);
      setLocation(props.location.search);
    }

    props.ventaObtenerVentas(
      {
        page: 0,
      },
      handleObtenerVentasAsync
    );
  }, []);

  if (!venta_id) {
    return '';
  }

  const handleVentaAnterior = () => {
    if (venta_id > 1) {
      const previous_venta_id = Number(venta_id) - 1;
      history.push(`/venta/${previous_venta_id}`);
      setVentaId(previous_venta_id);
    }
  };

  const handleVentaSiguiente = () => {
    if (venta_id < ultimo_venta_id) {
      const next_venta_id = Number(venta_id) + 1;
      history.push(`/venta/${next_venta_id}`);
      setVentaId(next_venta_id);
    }
  };

  if (ultimo_venta_id > 0) {
    const venta_html = (
      <VentaDetails
        id={venta_id}
        idCountry={props.idCountry}
        router_url={url}
        location={location}
        ultimo_venta_id={ultimo_venta_id}
        handleVentaAnterior={handleVentaAnterior}
        handleVentaSiguiente={handleVentaSiguiente}
      />
    );

    return (
      <>
        <ToggleUI show={venta_id % 2 === 0}>{venta_html}</ToggleUI>
        <ToggleUI show={venta_id % 2 !== 0}>{venta_html}</ToggleUI>
      </>
    );
  }
  return '';
};

const mapStateToProps = (state) => ({
  idCountry: state.tienda.Country_idCountry,
});

const mapDispatchToProps = (dispatch) => {
  return {
    ventaObtenerVentas: (data, callback) =>
      dispatch(ventaObtenerVentas(data, callback)),
  };
};

export const Venta = connect(mapStateToProps, mapDispatchToProps)(Venta_);
